import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  base: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    width: '100%',
    paddingVertical: 16,
  },
  prefix: {
    marginRight: 20,
  },
  label: {
    flexShrink: 1,
    flexGrow: 1,
    minWidth: 0,
  },
  suffix: {
    marginLeft: 12,
    flexShrink: 1,
    alignSelf: 'flex-start',
  },
});
